import { LSIDUserIdentity } from "@shopkeep/lsid-types";
import { fetchJSON } from "lib/fetch";
import { getStore } from "store";
import config from "site-config";
import { setLsidIdentity } from "../actions/lsid-actions";

export interface ILsidJwtResponse {
    lsid_identity: LSIDUserIdentity;
}

export interface IState {
    params: any;
    [prop: string]: any;
}

type TReplace = (params: any) => void;
type ICallback = () => void;

/**
 *  Request against the appserver /auth/oidc/identity endpoint (explicitly ignore token in response)
 */
export default (flags) => {
    return (nextState: IState, replace: TReplace, callback: ICallback) => {
        const store = getStore();
        const { restoreOidcIdentityEndpointInFrontendNu74731 } = flags;
        let url = `${config.api}/auth/oidc/identity`;

        if (restoreOidcIdentityEndpointInFrontendNu74731) {
            // Callout to Appserver /auth/oidc/identity
            return fetchJSON<ILsidJwtResponse>(url, { method: "GET" })
                .then((response) => {
                    store.dispatch(setLsidIdentity(formatPayload(response.lsid_identity)));
                    callback();
                })
                .catch((_error) => {
                    callback();
                });
        } else {
            // Callout to AuthLS (we want to deprecate this but have kept it here to ensure zero service disruption when we switch)
            url = `${config.LSID_IDENTITY_ROOT}/auth/identity`;

            return fetchJSON<LSIDUserIdentity>(url, { method: "GET" })
                .then((response) => {
                    store.dispatch(setLsidIdentity(formatPayload(response)));
                    callback();
                })
                .catch((_error) => {
                    callback();
                });
        }
    };
};

const formatPayload = function (identity: LSIDUserIdentity): any {
    return {
        userGrants: identity?.grants?.user || {},
        accountGrants: identity?.grants?.account || {},
        features: identity?.features || [],
        accountFeatures: identity?.accountFeatures || {},
        mfa: identity?.via?.hasOwnProperty("mfa"),
    };
};
